import Vue from 'vue'
import Vuex from 'vuex'
import { jwtDecode } from 'jwt-decode'
import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: null,
    usuario: null,
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setUsuario(state, usuario) {
      state.usuario = usuario;
    },
  },
  actions: {
    guardarToken({ commit }, token) {
      localStorage.setItem("t1", token);
      commit("setToken", token);
      commit("setUsuario", jwtDecode(token));

      router.push({ name: "bienvenido" }).catch(() => {});
    },
    autoLogin({ commit }) {
      let token = localStorage.getItem("t1");
      if (token) {
        commit("setToken", token);
        commit("setUsuario", jwtDecode(token));
      } else {
        router.push({ name: "inicioSesion" }).catch(() => { })
      }
    },
    salir({ commit }) {
      commit("setToken", null);
      commit("setUsuario", null);
      localStorage.removeItem("t1");
      router.push({ name: "inicioSesion" }).catch(() => { })
    },
  },
})
